import React from "react";
import CrudErrors from "components/CrudErros";
import {HelpAbility} from "helpers/HelpAbility";
import C from "helpers/HelpConstants";

const ClientCrudTableForm = ({setForm, form, createData, updateData, handleReset, errors}) => {

    const handleChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    }

    const handleChangeSelect = (e) => {
        var optionSelected = document.querySelector('#documentType').value;
        if (optionSelected !== "Seleccione") {
            setForm({...form, [e.target.name]: e.target.value});
        }
    }
    const handleChangeBool = (e) => {
        setForm({...form, [e.target.name]: e.target.value === 'true'});
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if (form._id === null) {
            createData(form);
        } else {
            updateData(form);
        }
    }
    let myAbi = HelpAbility();
    const isVisibleForm = () => (form._id === null) ? myAbi.has(C.A.CUSTOMER.CREATE) : myAbi.has(C.A.CUSTOMER.UPDATE);
    return (
        <>
            {isVisibleForm() && <div className="mt-4">
                <div className="row mb-2">
                    <h6>{form._id ? 'Editar' : 'Agregar'} Cliente</h6>
                </div>
                {errors && <CrudErrors errors={errors}/>}

                <div className="table-responsive rounded-3"
                     style={{border: '1px solid black', paddingTop: '15px', paddingBlock: '15px'}}>
                    <>
                        <div className="container">
                            <div className="d-flex">
                                <div className="col-10">
                                    <div className="row">
                                        <div className="col"
                                             style={{paddingRight: '10px', borderRight: '1px solid black'}}>
                                            <div className="row" style={{marginBottom: '10px'}}>
                                                <div className="col-5">
                                                    <label htmlFor="name" className="form-label">Nombre</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" className="form-control" id="name" name="name"
                                                           autoComplete="off" value={form.name}
                                                           onChange={handleChange}/>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginBottom: '10px'}}>
                                                <div className="col-5">
                                                    <label htmlFor="lastName" className="form-label">Apellidos</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" className="form-control" id="lastName"
                                                           name="lastName" autoComplete="off" value={form.lastName}
                                                           onChange={handleChange}/>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginBottom: '10px'}}>
                                                <div className="col-5">
                                                    <label htmlFor="numDocument" className="form-label">Numero de
                                                        Documento</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="number" className="form-control" id="numDocument"
                                                           name="numDocument" autoComplete="off"
                                                           value={form.numDocument}
                                                           onChange={handleChange}/>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-5">
                                                    <label htmlFor="name" className="form-label">Tipo de
                                                        Documento</label>
                                                </div>
                                                <div className="col-7">
                                                    <select className="form-select" aria-label="Default select example"
                                                            id="documentType" name="documentType"
                                                            value={form.documentType}
                                                            onChange={handleChangeSelect}>
                                                        <option value="">Seleccione</option>
                                                        <option value="CC">Cedula de Ciudadania</option>
                                                        <option value="CE">Cedula de Extrangeria</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col" style={{
                                            paddingRight: '10px',
                                            borderLeft: '1px solid black',
                                            borderRight: '2px solid black'
                                        }}>
                                            <div className="row" style={{marginBottom: '10px'}}>
                                                <div className="col-6">
                                                    <label htmlFor="mail" className="form-label">Correo
                                                        Electronico</label>
                                                </div>
                                                <div className="col-6">
                                                    <input type="text" className="form-control" id="mail" name="mail"
                                                           autoComplete="off" value={form.mail}
                                                           onChange={handleChange}/>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginBottom: '10px'}}>
                                                <div className="col-6">
                                                    <label htmlFor="maximumFinancingAmount" className="form-label">Monto
                                                        max. de Financiamiento</label>
                                                </div>
                                                <div className="col-6">
                                                    <input type="number" className="form-control"
                                                           id="maximumFinancingAmount" name="maximumFinancingAmount"
                                                           autoComplete="off" value={form.maximumFinancingAmount}
                                                           onChange={handleChange}/>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginBottom: '10px', height: '38px'}}>
                                                <div className="col-6">
                                                    <label htmlFor="name" className="form-label">Tiene Reserva
                                                        Activa</label>
                                                </div>
                                                <div className="col-6">
                                                    <div className="row">
                                                        <div className="col">
                                                            <input className="form-check-input" type="radio"
                                                                   name="hasActiveReserve" onChange={handleChangeBool}
                                                                   checked={form.hasActiveReserve === true}
                                                                   id="hasActiveReserve-radio-true" value={true}/>
                                                            <label className="form-check-label"
                                                                   htmlFor="hasActiveReserve-radio-true">Si</label>
                                                        </div>
                                                        <div className="col">
                                                            <input className="form-check-input" type="radio"
                                                                   name="hasActiveReserve" onChange={handleChangeBool}
                                                                   checked={form.hasActiveReserve === false}
                                                                   id="hasActiveReserve-radio-false" value={false}/>
                                                            <label className="form-check-label"
                                                                   htmlFor="hasActiveReserve-radio-false">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{height: '38px'}}>
                                                <div className="col-6">
                                                    <label htmlFor="name" className="form-label">Cliente en Mora</label>
                                                </div>
                                                <div className="col-6">
                                                    <div className="row">
                                                        <div className="col">
                                                            <input className="form-check-input" type="radio"
                                                                   name="hasMora"
                                                                   onChange={handleChangeBool}
                                                                   checked={form.hasMora === true}
                                                                   id="hasMora-radio-true"
                                                                   value={true}/>
                                                            <label className="form-check-label"
                                                                   htmlFor="hasMora-radio-true">Si</label>
                                                        </div>
                                                        <div className="col">
                                                            <input className="form-check-input" type="radio"
                                                                   name="hasMora"
                                                                   onChange={handleChangeBool}
                                                                   checked={form.hasMora === false}
                                                                   id="hasMora-radio-false"
                                                                   value={false}/>
                                                            <label className="form-check-label"
                                                                   htmlFor="hasMora-radio-false">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{height: '38px'}}>
                                                <div className="col-6">
                                                    <label htmlFor="name" className="form-label">Entidad Consultada</label>
                                                </div>
                                                <div className="col-6">
                                                    <div className="row">
                                                        <div className="col">
                                                            <input className="form-check-input" type="radio"
                                                                   name="hasEntidad"
                                                                   onChange={handleChangeBool}
                                                                   checked={form.hasEntidad === true}
                                                                   id="hasEntidad-radio-true"
                                                                   value={true}/>
                                                            <label className="form-check-label"
                                                                   htmlFor="hasEntidad-radio-true">Cifin</label>
                                                        </div>
                                                        <div className="col">
                                                            <input className="form-check-input" type="radio"
                                                                   name="hasEntidad"
                                                                   onChange={handleChangeBool}
                                                                   checked={form.hasEntidad === false}
                                                                   id="hasEntidad-radio-false"
                                                                   value={false}/>
                                                            <label className="form-check-label"
                                                                   htmlFor="hasEntidad-radio-false">DataCredito</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="themed-grid-col" style={{paddingLeft: '20px'}}>
                                        <div className="d-grid gap-2">
                                            {/*<button className="btn btn-info me-2" type="submit" onClick={handleSubmit}>{form._id ? 'Actualizar' : 'Guardar'}</button> */}
                                            {/*'btn btn-' + form._id ? 'info' : 'primary' + ' me-2'*/}
                                            <button className={'btn btn-' + (form._id ? 'success' : 'primary')}
                                                    type="submit" onClick={handleSubmit}><i
                                                className="bi bi-save"/>{form._id ? 'Actualizar' : 'Guardar'}</button>
                                            <button type="reset" className="btn btn-secondary" onClick={handleReset}><i
                                                className="bi bi-eraser"/> Limpiar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>}
        </>
    );
}
export default ClientCrudTableForm;
